import React, { useEffect, useState } from 'react';
import { CircularProgress } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { asyncFetch, getAppData } from '../../helperFunctions';
import TaskCard from './TaskCard';
import { setData } from '../redux';
import SugnatureWindows from './SugnatureWindows';

export default () => {
  const dispatch = useDispatch();
  const data = useSelector(state => state.tasks.data);
  const signedTechnicians = useSelector(state => state.tasks.signedTechnicians);
  const showTaskDetails = useSelector(state => state.tasks.showTaskDetails);
  const isAdmin = useSelector(state => state.auth.isAdmin);
  const [errorResponse, setErrorResponse] = useState(false);
  const [materialsLoadState, setMaterialsLoadState] = useState({ loading: false, loaded: false });

  useEffect(() => {
    if (!data.loaded) {
      (async () => {
        await getAppData({ data, dispatch });
      })();
    }
  }, [data, dispatch]);

  useEffect(() => {
    if (data.loaded && !materialsLoadState.loaded && !materialsLoadState.loading) {
      setMaterialsLoadState({ ...materialsLoadState, loading: true });
      (async () => {
        const response = await asyncFetch(
          `${process.env.REACT_APP_TECHNICIANS_API}/Tasks/get-materials`,
          {},
          {},
          undefined,
          dispatch
        );

        if (response) {
          if (Object.keys(response).includes('materials')) {
            dispatch(setData({ ...data, ...response }));
            setMaterialsLoadState({ loading: false, loaded: true });
          } else {
            setErrorResponse(true);
            setMaterialsLoadState({ loading: false, loaded: false });
          }
        }
      })();
    }
  }, [data, materialsLoadState, dispatch]);

  return data.tasks.length > 0 ? (
    <>
      <SugnatureWindows technicians={data.scheduleByDate.techniciansData} />
      {((!showTaskDetails.open && signedTechnicians.show) || (!showTaskDetails.open && isAdmin)) &&
        data.tasks.map(x => <TaskCard key={x.id} task={x} />)}
    </>
  ) : (
    <>
      {!isAdmin && (
        <div
          style={{
            position: 'fixed',
            left: '50%',
            top: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        >
          {data.loaded ? (
            <>{errorResponse ? 'Възникна системна грешка' : 'Няма задачи за деня'}</>
          ) : (
            <CircularProgress />
          )}
        </div>
      )}
    </>
  );
};
